import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  hideFirstOption?: boolean;
  mode?: 'multiple';
  status?: string | string[];
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  onChange?: ((value: any, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const InvoiceStatusSelect: React.FC<IProps> = memo(
  ({ hideFirstOption = false, mode, status, size, style, onChange }) => {
    const isMultiple = mode === 'multiple';
    return (
      <Select
        mode={mode}
        style={{ width: 100, ...style }}
        allowClear={isMultiple}
        maxTagCount={isMultiple ? 'responsive' : undefined}
        placeholder={isMultiple ? L('All') : undefined}
        defaultValue={isMultiple ? undefined : 'All'}
        value={status}
        size={size}
        onChange={onChange}
      >
        {!isMultiple && !hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        <Option value="Unpaid">{L('Unpaid')}</Option>
        <Option value="Paid">{L('Paid')}</Option>
        <Option value="Voided">{L('Voided')}</Option>
      </Select>
    );
  }
);
